import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const EditScholarshipCampaigns = () => {
  return (
    <Edit
      title="Редактиране на кампания за стипендии"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditScholarshipCampaigns;
